import { type FC, type ReactElement, type ReactNode } from 'react'

export type DropdownOptionType<T> = {
  label: ReactNode
  value: T
}

export type MenuOptionType = {
  isHeading?: boolean
  label: ReactNode
}

export type DropdownOptionGroupType<T extends string = string> = {
  label?: string
  options: DropdownOptionType<T>[]
}

export type TypeaheadDynamicModeType = 'all' | 'card' | 'commander' | 'partner'

export type TypeaheadStaticModeType = 'set'

export type TypeaheadOptionType<T extends string = string> = {
  Component?: FC<{ children: ReactElement }>
  label?: string
  labelDisplay?: ReactNode
  type?: 'heading'
  value: T
}

export type TypeaheadOptionGroupType<T extends string = string> = {
  Component?: FC<{ children: ReactNode }>
  options: TypeaheadOptionType<T>[]
}

export type WiggleType = 'a' | 'b'

export type InputProps = {
  border?: 'none'
  borderColor?: 'warning'
  colorScheme?: 'muted' | 'none'
  size?: 'sm' | 'lg'
  width?: 'maxcontent'
  wiggle?: WiggleType
}

export const extractInputProps = <T extends InputProps>({
  border,
  borderColor,
  colorScheme,
  size,
  width,
  wiggle,
  ...rest
}: T) => ({
  inputProps: { border, borderColor, colorScheme, size, width, wiggle },
  rest,
})

export const RESET_DEFAULT = { label: 'Reset', value: '' } as const
